import LinkCopy from "../../../c/LinkCopy"
import React, { useContext, useState } from "react"
import { T } from "../../../traks"
import WhistlesContext from "../../../contexts/whistlesContext"
import { Col, Container, Row } from "reactstrap"
import QAndAs from "./NoWhistlesQues"
import { Questions } from "../../../c/FAQ"

export const NoWhistles = () => {
	const { noWhistlesLink } = useContext(WhistlesContext)
	const [compactQIndex, setCompactQIndex] = useState(-1);

	const selectIfNotSelected = (i) => {
		if (i === compactQIndex) {
			setCompactQIndex(-1);
		} else {
			setCompactQIndex(oi => i);
		}
	}

	return (
		<Container >
			<Row>
				<Col xs={12} lg={10} className="mx-auto">
					<div className="text-center">
						<img src="https://static.sibilus.eu/gfx/no_whistles_image-0.svg" alt='no whistles' />
						<div className="primary fs-4 mt-5">
							<T>You have no assigned cases yet</T>
						</div>
						<div>
							<T>Test and share the link below to your employees</T>
							<br />
							<T>in order to submit cases</T>
						</div>
					</div>
					<div className="mt-4 mx-auto" style={{ maxWidth: "60rem" }}>
						<LinkCopy
							link="create-whistle"
							pathId={noWhistlesLink}
						/>
					</div>
					<div className="mt-5 border_radius_10px overflow-hidden">
						<Questions
							questionsList={QAndAs}
							selectedIndex={compactQIndex}
							selectQuestion={selectIfNotSelected}
							lastIndex={QAndAs.length - 1}
							compact
						/>
					</div>
				</Col>
			</Row>
		</Container>
	)
}

